import { ChakraProvider } from "@chakra-ui/react";
import { BrowserRouter } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import { RecoilRoot } from "recoil";
import "./App.css";
import RouterController from "./routes/routes";
import "react-toastify/dist/ReactToastify.css";
import axios from "axios";
import api from "./services/api";

function App() {
  if (window.localStorage.getItem("token")) {
    const token = window.localStorage.getItem("token") || "";
    api.defaults.headers.common["Authorization"] = `${token}`;
  }

  return (
    <ChakraProvider>
      <RecoilRoot>
        <BrowserRouter>
          <RouterController />
          <ToastContainer />
        </BrowserRouter>
      </RecoilRoot>
    </ChakraProvider>
  );
}

export default App;
